import { __read, __assign } from 'tslib';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';

/**
 * 弹窗Mask
 * @param {object} props
 * @param {boolean} props.maskClosable mask是否可点
 * @param {boolean} props.show 是否显示
 * @param {boolean} props.isResetBody 是否重置内容
 * @param {function} props.onClose 关闭
 * @returns TSX.Element
 */
function UModalMask(props) {
  var _a = props.isResetBody,
    isResetBody = _a === void 0 ? true : _a,
    style = props.style,
    onClose = props.onClose,
    maskClosable = props.maskClosable,
    show = props.show;
  var _b = __read(useState('0'), 2),
    opacity = _b[0],
    setOpacity = _b[1];
  var _c = __read(useState('none'), 2),
    display = _c[0],
    setDisplay = _c[1];
  var rootNode = useRef(null);
  var isDestroy = useRef(false);
  var html = useRef(null);
  var body = useRef(null);
  var scrollTop = useRef(null);
  var resetBodyAttr = useCallback(function () {
    setOpacity('0');
    isDestroy.current = true;
    if (isResetBody && document.body.classList.contains('header-body-no-scroll')) {
      document.body.classList.remove('header-body-no-scroll');
      document.body.style.top = '';
      document.body.style.overflowY = '';
      window.scrollTo({
        top: scrollTop.current
      });
      // 重置scrollTop
      scrollTop.current = null;
    }
  }, [isResetBody]);
  useEffect(function () {
    html.current = document.querySelector('html');
    body.current = document.body;
    if (show) {
      setDisplay('block');
      setTimeout(function () {
        setOpacity('1');
      }, 100);
      isDestroy.current = false;
      // body 不可移动
      // 判断是否要重新计算scrollTop
      if (!scrollTop.current) {
        scrollTop.current = window.scrollY;
      }
      document.body.classList.add('header-body-no-scroll');
      document.body.style.top = "-".concat(scrollTop.current || 0, "px");
      // 判断body本身是否可以滚动，如果可以滚动加上scroll，保证有滑动条
      if (document.body.scrollHeight > document.body.clientHeight) {
        document.body.style.overflowY = 'scroll';
      }
    } else {
      resetBodyAttr();
    }
    return function () {
      resetBodyAttr();
    };
  }, [show, resetBodyAttr]);
  var clickMaskHandler = function clickMaskHandler() {
    if (maskClosable) {
      resetBodyAttr();
    }
  };
  var onTransitionEndHandler = function onTransitionEndHandler(isDestroy) {
    var _a;
    if (isDestroy) {
      onClose && onClose();
      var parent_1 = (_a = rootNode.current) === null || _a === void 0 ? void 0 : _a.parentElement;
      var parentTagName = parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.tagName;
      var rootEle = parentTagName === 'DIV' ? parent_1 : rootNode.current;
      ReactDOM.unmountComponentAtNode(rootEle);
      rootEle.remove();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    onTransitionEnd: function onTransitionEnd() {
      return onTransitionEndHandler(isDestroy.current);
    },
    className: "no-rem-u-modal-mask",
    style: __assign(__assign({}, style), {
      opacity: opacity,
      display: display
    }),
    onClick: clickMaskHandler,
    ref: rootNode
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    className: "u-modal-mask-content-container",
    style: {
      opacity: opacity
    }
  }, props.children));
}

export { UModalMask };
